// src/components/common/LogoMikDok.jsx


function MikDokMark({ size = 32, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
  <g fill={color}>
    <rect x="23.3" y="117.2" width="102" height="30" rx="18" transform="rotate(-52 23.3 117.2)" />
    
    <rect x="71.8" y="118.2" width="102" height="30" rx="18" transform="rotate(-52 71.8 117.2)" />
    
    <rect x="151.5" y="94" width="13" height="35" rx="6.5" /> <rect x="140.5" y="105" width="35" height="13" rx="6.5" /> </g>
</svg>
  );
}

export default function LogoMikDok({
  size = 32, // icon size
  badge = 48, // gradient badge size
  showText = true,
  subtitle = "Patient",
  textColor = "#111827",
  
}) {
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>
      <div
        style={{
          width: badge,
          height: badge,
          borderRadius: 20,
          display: "grid",
          placeItems: "center",
          background: "linear-gradient(135deg, #3b82f6, #6366f1)",
          boxShadow: "0 10px 25px -5px rgba(59,130,246,0.30)",
        }}
      >
        {/* SVG logo (white inside the gradient badge) */}
        <MikDokMark size={size} color="#ffffff" />
      </div>

      {showText && (
        <div style={{ lineHeight: 1.05 }}>
          <div
            style={{
              fontSize: 18,
              fontWeight: 800,
              letterSpacing: "-0.02em",
              color: textColor,
            }}
          >
            MikDok
          </div>
          {subtitle ? (
            <div style={{ fontSize: 12, color: "#64748B", marginTop: 2 }}>
              {subtitle}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
